import { isBefore } from 'date-fns';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import { BindGrid, exportToExcel, setTitle, setFocus } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import { getCommonData } from '../Common/CommanServices';

const EmptyItemPriceMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [MenuText, setMenuText] = useState("Item Group Master");
    const [EmptyItemGroupOption, setEmptyItemGroupOption] = useState([]);
    const [EffectiveDate, seteffectiveDate] = useState(new Date());
    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        EmptyPriceID: "0",
        EmptyItem: "",
        Price: "",
        Active: true,
    });

    const handleClear = async () => {
        setSaveData({
            EmptyPriceID: "0",
            EmptyItem: "",
            Price: "",
            Active: true,

        });
        seteffectiveDate(new Date());
        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)
    }

    useEffect(() => {
        setTitle('EmptyItemPriceMaster', setOpen);
        setFocus('txtEmptyItem');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        getEmptyItemPriceData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit = () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString, EffectiveDate: document.getElementById('txtEffectiveDate').value, Price: `${SaveData.Price}`
        }
        post(`${API_SERVER}/api/Master/InsertUpdateEmptyPrice`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
                handleClear();
                getEmptyItemPriceData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
            }
            if (res.focus !== "") {
                AlertBox(res.status, res.message, res.focus)
                setFocus(res.focus)
            }
        })
    }
    const getEmptyItemPriceData = (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExEmptyPrice`, { ...data }, (res) => {

            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'EmptyItemPriceMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]
                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            setIsLoading(false)
        })
    }
    const handleEditData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, EmptyPriceID: ID
        }
        post(`${API_SERVER}/api/Master/EditEmptyPrice`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    EmptyPriceID: ID,
                    EmptyItem: editRecordJson[0]['ItemNo'],
                    Price: editRecordJson[0]['Price'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false)
                });
                seteffectiveDate(editRecordJson[0]['EffectiveDate'])
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }
    const handleDeleteData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, EmptyPriceID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteEmptyPrice`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus)

                getEmptyItemPriceData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
            }
        })
    }


    const getItem = () => {
        setEmptyItemGroupOption([]);
        let temp = {
            Type: "GetEmptyItem",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let ItemData = res.autoCompleteData || [];
                setEmptyItemGroupOption(ItemData);
            } else {
                setEmptyItemGroupOption([]);
            }
        });
    };
    let EmptyItemOptionArr = []
    for (let i = 0; i < EmptyItemGroupOption.length; i++) {
        let mydata = EmptyItemGroupOption[i]?.values
        EmptyItemOptionArr.push(mydata)
    };


    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getEmptyItemPriceData();
    }
    const handleDownloadExcel = async () => {
        getEmptyItemPriceData('E');
    }
    const filterFutureDates = (date) => {
        return isBefore(date, new Date());
    }
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">

                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItemPrice") };
                                                }}
                                                label='Empty Item'
                                                placeholder="Enter Empty Item"
                                                maxLength='50'
                                                options={EmptyItemOptionArr}
                                                id='txtEmptyItem'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getItem()}
                                                inputValue={SaveData.EmptyItem ? SaveData.EmptyItem : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, EmptyItem: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                   
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Item Price <span className="Required">*</span></label>
                                            <input
                                                id="txtItemPrice"
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Item Price'
                                                value={SaveData.Price}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Price: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Effective Date  <span className="Required">*</span></label>
                                            <DatePicker
                                                selected={EffectiveDate}
                                                id='txtEffectiveDate'
                                                className="form-control"
                                                placeholderText='Effective Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => seteffectiveDate(date)}
                                               // filterDate={filterFutureDates}
                                                //maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="chkActive"
                                                name='Active'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("btnSave") };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.EmptyPriceID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id="btnSave" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle} handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='EmptyItemPriceMaster' />

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default EmptyItemPriceMaster